var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5389.77 6393.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1538.3,
    y1: 1061.02,
    x2: 5719.35,
    y2: 6043.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#79cbf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4b92ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3374ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1118.06,
    y1: 6574.61,
    x2: 2283.86,
    y2: -36.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#79cbf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4b92ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3374ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4148.97,
    y1: 5651.94,
    x2: 1178.91,
    y2: 6732.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#79cbf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4b92ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3374ec"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5221.74,6356.4c-560.13-264.45-2290.79-1050.39-2385.56-1131.89-23.65-20.34-35.39-51.65-37.29-75.5-62.57-1691.88-31.47-3405.98-20.5-5114.44.25-39.66,69.51-46.61,82.78-13.48.24.61.48,1.2.75,1.8,44.47,98.82,283.03,629.13,285.51,639.71l.11.41c354.94,879.93,793.52,1978.07,1148.86,2862.98,20.64,51.4-1.25,110.05-50.51,135.36l-303.41,155.9c-56.16,28.86-124.96,3.17-148.47-55.43-109.69-273.43-293.61-732.19-388.72-969.68-16.3-40.71-76.82-29.06-76.85,14.79l-1.76,1988.62c-.03,29.82,17.13,56.98,44.07,69.76l980.35,465.04c32.77,15.54,67.58-17.2,54.07-50.86-71.57-179.35-217.02-539.99-289.35-716.6,0,0-38.85-94.89-58.54-144.83-18.1-51.59-7.95-68.07,32.72-88.94,40.67-20.87,381.23-195.66,381.23-195.66,30.85-15.83,68.63-1.73,81.56,30.44l76.88,191.36c.2.49.67.81,1.2.81h0c.53,0,1,.32,1.2.81,0,0,483.22,1247.93,747.02,1854.98,37.2,85.61-24.62,207.19-157.35,144.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1797.05,1797.37c67.42-208.11,598.38-1649.42,650.57-1767.02,1.86-4.19,6.29-13.13,10.61-18.74,14.13-19.23,64.46-14.43,74.69,13.28,19.17,36.79,11.88,3436.8,3.12,5135.96-.03,5.39-1.85,18.08-7.7,33.5-1.06,2.8-3.92,7.49-5.48,10.55-8.97,17.57-23.21,31.11-29.17,35.84-78.82,62.6-269.22,159.42-345.51,197.41-21.1,10.51-60.12,14.53-89.26,4.34-11.94-4.18-38.85-14.79-42.46-56.01-.17-1.89.12-28.01.12-28.01l49.97-2533.75c-.05-44.44-61.38-56.23-77.89-14.97-132.06,329.63-481.59,1202.29-618.69,1542.84-149.05,364.6-546.14,1354.75-707.45,1756.35-3.05,7.6-17.47,28.57-30.62,35.81-97.13,53.45-485.92,239-485.92,239-83.84,39.77-172.91-44.01-138.33-130.13l756.07-1883.12h1c316.59-783.31,718.22-1791.25,1032.34-2573.13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2624.4,5426.75l-1541.56,766.13c-101.43,50.41-64.83,201.4,48.74,201.04l3130.55-9.79c114.19-.36,149.26-152.89,46.4-201.85l-1589-756.33c-30.12-14.33-65.27-14.04-95.14.8Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f66a1f315e4b0aa58e080aa523fd5827.svg";
export { ForwardRef as ReactComponent };